export const MODE: string = process.env.REACT_APP_MODE || 'local';

let apiLink = '';

switch (process.env.REACT_APP_MODE) {
  case 'prod':
    apiLink = 'https://beta-api.substrata.me';
    break;
  case 'stage':
    apiLink = 'https://staging.beta-api.substrata.me';
    break;
  default:
    apiLink = 'http://localhost:8002';
    break;
}

export const API_LINK: string = process.env.REACT_APP_API_LINK || apiLink;

let signupLink = '';

switch (process.env.REACT_APP_MODE) {
  case 'prod':
    signupLink = 'https://signup.substrata.me';
    break;
  case 'stage':
    signupLink = 'https://staging.signup.substrata.me';
    break;
  default:
    signupLink = 'http://localhost:3002';
    break;
}

export const SIGNUP_LINK: string =
  process.env.REACT_APP_SIGNUP_URL || signupLink;
